export default "__VITE_ASSET__2fc19027__"